var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6235_154832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9V6.55556C17 6.35128 16.9591 6.149 16.8797 5.96027C16.8002 5.77154 16.6838 5.60006 16.537 5.45561C16.3902 5.31116 16.216 5.19658 16.0242 5.11841C15.8324 5.04024 15.6268 5 15.4192 5H6.58077C6.16152 5 5.75945 5.16389 5.463 5.45561C5.16654 5.74733 5 6.143 5 6.55556V17.4444C5 17.857 5.16654 18.2527 5.463 18.5444C5.75945 18.8361 6.16152 19 6.58077 19H9",
    stroke: "#EE5294",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5H14",
    stroke: "#EE5294",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H14",
    stroke: "#EE5294",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5H12",
    stroke: "#EE5294",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4759 14.7007L15.7265 18.4539L13 19L13.5455 16.2707L17.295 12.5175C17.4353 12.3606 17.6061 12.2338 17.7969 12.145C17.9877 12.0562 18.1946 12.0071 18.4049 12.0007C18.6152 11.9943 18.8247 12.0308 19.0205 12.1079C19.2163 12.1851 19.3944 12.3012 19.544 12.4494C19.694 12.598 19.8119 12.776 19.8902 12.9722C19.9686 13.1684 20.0057 13.3786 19.9993 13.5898C19.9929 13.8011 19.9432 14.0087 19.8531 14.1998C19.7631 14.3909 19.6347 14.5614 19.4759 14.7007Z",
    stroke: "#EE5294",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4243,
    y1: 12.5757,
    x2: 19.4243,
    y2: 15.5757,
    stroke: "#EE5294",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6235_154832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.7cf8fa48fe0b385ad1687722ce9c5f6a.svg";
export { ForwardRef as ReactComponent };